export default {
    SET_USERS(state, users) {
        state.users = users;
    },
    REQUEST_OK(state, message) {
        state.statusMessage = message;
    }
}